import {Branded, brand, string} from 'io-ts';

export const BankId = brand(string, (n): n is BankId => true, 'BankId');

export type BankId = Branded<
    string,
    {
        readonly BankId: unique symbol;
    }
>;
